import React, { Component } from "react";

class GiftCard extends Component {
  render() {
    return (
      <iframe
        width='100%'
        height='1700px'
        frameBorder='0'
        scrolling='no'
        src='https://vgdelivery.com/VirtualGiftCard?programId=28429&currentCulture=0'
      ></iframe>
    );
  }
}

export default GiftCard;



// WEBPACK FOOTER //
// ./src/components/GiftCard.jsx